// Google Tag Manager initialization (Production Only)

const GTM_ID = 'GTM-MCWCKQ79';

export const initializeGTM = (): void => {
    // Only load GTM in production
    if (!import.meta.env.PROD) {
        console.log('🏷️ GTM: Skipped in development mode');
        return;
    }

    // Initialize dataLayer
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        'gtm.start': new Date().getTime(),
        event: 'gtm.js'
    });

    // Load GTM script
    const script = document.createElement('script');
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtm.js?id=${GTM_ID}`;
    document.head.insertBefore(script, document.head.firstChild);

    // Add noscript fallback to body
    const noscript = document.createElement('noscript');
    const iframe = document.createElement('iframe');
    iframe.src = `https://www.googletagmanager.com/ns.html?id=${GTM_ID}`;
    iframe.height = '0';
    iframe.width = '0';
    iframe.style.display = 'none';
    iframe.style.visibility = 'hidden';
    noscript.appendChild(iframe);
    document.body.insertBefore(noscript, document.body.firstChild);

    console.log('🏷️ GTM: Initialized with ID:', GTM_ID);
};

